import type { TemplateAssignmentScope } from '@Application/Documents/TemplateAssignments/TemplateAssignmentScope';

// The bare enum value, wrapped in an object: synapse's `DefaultPayload` forbids a bare scalar. The
// `204` response carries no body — the store cannot resolve what now applies without a refetch, so it
// invalidates instead of computing a replacement (`state-stores.md`, "Étendre un store").
export type TemplateAssignmentClearedPayload = {
	documentTypeId: number;
};

export type TemplateAssignmentClearedAction = {
	type: 'TEMPLATE_ASSIGNMENT_CLEARED';
	payload: TemplateAssignmentClearedPayload;
	scope: TemplateAssignmentScope;
};

export default (
	payload: TemplateAssignmentClearedPayload,
	scope: TemplateAssignmentScope,
): TemplateAssignmentClearedAction => ({
	type: 'TEMPLATE_ASSIGNMENT_CLEARED',
	payload,
	scope,
});
